import { TextField } from '@mui/material';
import styled from 'styled-components';

export const CurveDrawerForm = styled.form``;

export const Input = styled(TextField)`
	background-color: white !important;
`;
